import { render, staticRenderFns } from "./moduleList.vue?vue&type=template&id=d147e0e4&scoped=true&"
import script from "./moduleList.vue?vue&type=script&lang=js&"
export * from "./moduleList.vue?vue&type=script&lang=js&"
import style0 from "./moduleList.vue?vue&type=style&index=0&id=d147e0e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d147e0e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
